/* tslint:disable */

declare var Object: any;
export interface AnalyticsInterface {
  "id"?: number;
}

export class Analytics implements AnalyticsInterface {
  "id": number;
  constructor(data?: AnalyticsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Analytics`.
   */
  public static getModelName() {
    return "Analytics";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Analytics for dynamic purposes.
  **/
  public static factory(data: AnalyticsInterface): Analytics{
    return new Analytics(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Analytics',
      plural: 'Analytics',
      path: 'Analytics',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Analytics.ts